export default __webpack_public_path__ + "static/media/flam.9a9eb75c.png";